import React from 'react';
import { Box, SimpleGrid, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';

function formatDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString();
}

function Detail({ label, value }) {
  const mutedColor = useColorModeValue('gray.500', 'gray.400');
  const titleColor = useColorModeValue('navy.800', 'white');
  return (
    <Box>
      <Text fontSize="10px" fontWeight="800" color={mutedColor} textTransform="uppercase" mb={1} letterSpacing="0.05em">
        {label}
      </Text>
      <Text fontSize="sm" fontWeight="700" color={titleColor}>
        {value || '—'}
      </Text>
    </Box>
  );
}

export default function TransportPlanCard({
  transportPlan,
  title = 'Transport plan',
  subtitle = 'Confirmed fleet and dates for the assigned transport.',
}) {
  const borderColor = useColorModeValue('gray.100', 'whiteAlpha.200');
  const mutedColor = useColorModeValue('gray.500', 'gray.400');
  const titleColor = useColorModeValue('navy.800', 'white');
  const cardBg = useColorModeValue('white', 'navy.800');
  const {t} = useTranslation();
  return (
    <Box border="1px solid" borderColor={borderColor} borderRadius="22px" p={5} bg={cardBg}>
      <Stack spacing={4}>
        <Box>
          <Text fontSize="md" fontWeight="800" color={titleColor}>
            {t(title)}
          </Text>
          <Text fontSize="sm" color={mutedColor} mt={1}>
            {t(subtitle)}
          </Text>
        </Box>

        {transportPlan ? (
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            <Detail label="Truck" value={transportPlan.truck?.label || transportPlan.truck?.licensePlate} />
            <Detail label="Driver" value={transportPlan.driver?.label} />
            <Detail label="Trailer" value={transportPlan.trailer?.label || 'Not assigned'} />
            <Detail label="Planned pickup" value={formatDate(transportPlan.pickupDate)} />
            <Detail label="Planned delivery" value={formatDate(transportPlan.deliveryDate)} />
          </SimpleGrid>
        ) : (
          <Text fontSize="sm" color={mutedColor}>
            {t('The partner has not confirmed the transport plan yet.')}
          </Text>
        )}
      </Stack>
    </Box>
  );
}
